const autoNgTemplateLoaderTemplate1 = require('./gitlabProjectsDatatable.html');

angular.module('shbdeployer.app').component('gitlabProjectsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GitlabProjectsDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    state: '=',
  },
});
